import cutFilter from './cut.text.filter';
import decodeFilter from './decode.filter';
import escapeFilter from './escape.filter';
import imageSizeFilter from './image-size.filter';

export default angular
  .module('fizyweb.paycell.common.filters', [])
  .filter('cut', cutFilter)
  .filter('imageSize', imageSizeFilter)
  .filter('decode', decodeFilter)
  .filter('escape', escapeFilter).name;



// WEBPACK FOOTER //
// src/app/common/filters/filters.module.ts